import { FC, useMemo, ReactNode } from 'react'
import { PageHeading } from 'components/atoms/Text'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { PageAnchorHandler } from 'handlers/PageAnchorHandler/PageAnchorHandler'
import styles from 'components/features/creditCard/creditCardPage/CreditCardPagePreset/CreditCardPagePreset.styl'
import { InternalPageRedirect } from 'components/features/pfm/InternalPageRedirect/InternalPageRedirect'

type CreditCardPagePresetProps = {
  title?: string
  className?: string
  footerChild?: ReactNode
}
export const CreditCardPagePreset: FC<CreditCardPagePresetProps> = (props) => {
  const {
    children,
    className,
    title = 'Your Credit Card',
    footerChild,
  } = props

  const notificationsChild = useMemo(() => (
    <NotificationTrayWrapper
      renderLevel='page'
      isPositionRelative
    />
  ), [])

  const sidebarChild = useMemo(() => (
    <InternalSidebarContainer />
  ), [])

  return (
    <InternalPageRedirect>
      <PageAnchorHandler placement='creditcard'>
        <div className={ styles.anchorPlaceholder } />
      </PageAnchorHandler>

      <InternalLayoutContainer
        sidebar={ sidebarChild }
        notifications={ notificationsChild }
      >
        <div>
          <SingleColumnLayout>
            <PageHeading className={ styles.pageHeading }>
              { title }
            </PageHeading>
            <main className={ className }>
              { children }
            </main>
          </SingleColumnLayout>
          { footerChild }
        </div>
      </InternalLayoutContainer>
    </InternalPageRedirect>
  )
}
